import {css} from 'lit';

import {defaultStyles} from '../../../components/pagination.js';

export const styles = defaultStyles.extends({
  statics: css``,
  colorGen: () => '',
  gradientGen: () => '',
  sizeGen: () => '',
});

export default {styles};
